import React from 'react'
import { Input } from 'components/ui'
import { FaMicrophone, FaStop } from 'react-icons/fa'
import useSpeechRecognition from 'utils/hooks/useSpeechRecognition'

const SpeechInput = (props) => {
    const { onChange, value, ...rest } = props

    const { isListening, stopListening, toggleListening, isSupported } = useSpeechRecognition((transcript) => {
        if (onChange) {
            // Append or replace? Let's go with append if there's existing value, for better UX
            const newValue = value ? `${value} ${transcript}` : transcript;
            onChange({ target: { value: newValue } })

            // For standard STT, we usually stop after one result to avoid confusion, 
            // unless continuous mode is preferred. Continuous is on in the hook, 
            // but let's give control.
        }
    })

    const micButton = (
        <div
            className="cursor-pointer p-1 flex items-center justify-center transition-all duration-200"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleListening();
            }}
        >
            {isListening ? (
                <div className="flex items-center gap-1 group">
                    <span className="text-[10px] text-red-500 font-bold opacity-0 group-hover:opacity-100 transition-opacity">STOP</span>
                    <FaStop className="text-red-500 animate-pulse text-lg" />
                </div>
            ) : (
                <FaMicrophone className="text-gray-400 hover:text-[#1E6C56] text-lg" title="Start speech to text" />
            )}
        </div>
    );

    if (!isSupported) {
        return <Input {...props} />
    }

    // If it's a textArea, the UI library's Input component might drop the suffix prop.
    // So we wrap it and absolutely position the microphone button.
    if (rest.textArea) {
        return (
            <div className="relative w-full">
                <Input
                    {...rest}
                    className={(rest.className || "") + " pr-10"}
                    value={value}
                    onChange={onChange}
                />
                <div className="absolute top-2 right-2 z-10 p-0.5 rounded-md backdrop-blur-sm bg-white/80 hover:bg-white text-gray-500 transition-colors shadow-sm border border-gray-200">
                    {micButton}
                </div>
            </div>
        );
    }

    return (
        <Input
            {...rest}
            value={value}
            onChange={onChange}
            suffix={micButton}
        />
    )
}

export default SpeechInput
